import type { SelectedOs } from "@/modules/compute/os/os.ts";
import type { ManagedServiceLoc } from "@/modules/services/servicesQuery.ts";
import type { ManagedServiceEnum } from "@warrenio/api-spec/spec.oats.gen";

export interface ServiceOs extends SelectedOs {
    os_name: ManagedServiceEnum;
    os_version: string;

    /** Prevent extra fields and force usage of {@link extractServiceOs} */
    service?: never;
}

export function extractServiceOs(obj: ManagedServiceLoc): ServiceOs {
    return { os_name: obj.service, os_version: obj.version };
}
